import React from "react"
import { DateRangePickerSeeker } from "@ui-seeker/core"

import { dateRange } from "@signals"


export default function AppCommonFiltersDateRangePicker({ ...props }) {

	return <DateRangePickerSeeker
		value={dateRange.value}
		onChange={e => dateRange.value = e}
		label="Date Range"
		{...props}
	/>
}
